export const MAX_ACTIVE_SCENARIOS = 5

/**
 * Remove the following scenarios from the list of available scenario templates for now
 * {
    name: 'Sales',
    prompt:
      'Visitors who express interest in purchasing products/services via cues such as inquiries about discounts, pricing options, upgrades, pricing, promotions, and more.',
    description:
      'Triggered by visitors who express interest in purchasing products/services via cues such as inquiries about discounts, pricing options, upgrades, pricing, promotions, and more.',
    driftManaged: true,
    id: 'SALES',
  },
  {
    name: 'Support',
    prompt:
      'When visitors seek help for product or service issues via cues such as needing assistance, troubleshooting, or seeking customer service, only after the bot attempts to resolve their issues given the available information.',
    description:
      'Triggered when visitors seek help for product or service issues via cues such as needing assistance, troubleshooting, or seeking customer service, only after the bot attempts to resolve their issues given the available information.',
    driftManaged: true,
    id: 'SUPPORT',
  },
 */
export const SCENARIO_TEMPLATES = [
  {
    name: 'Events',
    prompt:
      'When visitors inquire about a calendar of events, webinars, or other company hosted events',
    description:
      'Triggered when visitors inquire about a calendar of events, webinars, or other company hosted events',
    scenarioExamples: [
      'How do I sign up for the upcoming webinar?',
      'Can I access recordings of previous events?',
      'Where can I find a list of your upcoming and past events?',
      'What is the next event?',
    ],
    id: 'EVENTS',
  },
  {
    name: 'Partnerships',
    prompt: 'When visitors ask about partnership oppportunities or programs',
    description:
      'Triggered when visitors ask about partnership oppportunities or programs',
    scenarioExamples: [
      'Do you have a partner program?',
      'How can I partner with [company name]?',
      'Where can I see partnership information?',
    ],
    id: 'PARTNERSHIPS',
  },
  {
    name: 'Job Seekers/Careers',
    prompt:
      'When visitors inquire about job or career opportunities at the company, open roles, or the benefits of working at the company',
    description:
      'Triggered when visitors inquire about job or career opportunities at the company, open roles, or the benefits of working at the company',
    scenarioExamples: [
      'Are you hiring?',
      'What jobs do you have open?',
      'Where can I find a list of employee benefits?',
      'Can I work for [company name]?',
    ],
    id: 'CAREERS',
  },
  {
    name: 'Trials',
    prompt:
      'When visitors inquire about free trials, freemium subscriptions/tiers, or the ability to try the product or service before they purchase it',
    description:
      'Triggered when visitors inquire about free trials, freemium subscriptions/tiers, or the ability to try the product or service before they purchase it',
    scenarioExamples: [
      'Do you have a free trial?',
      'Can I try out your product or service before buying?',
      'Is there a 30 day trial?',
      'Can I start a free trial?',
      'Sign up for trial',
    ],
    id: 'TRIALS',
  },
  {
    name: 'Pricing',
    prompt:
      'When a visitor asks how much a product or service costs, if they could recieve a quote, or how expensive a product/service would be',
    description:
      'Triggered when a visitor asks how much a product or service costs, if they could recieve a quote, or how expensive a product/service would be',
    scenarioExamples: [
      'How much does it cost?',
      'Can you send me a quote?',
      'What are your pricing tiers?',
    ],
    id: 'PRICING',
  },
  {
    name: 'Demos',
    prompt:
      'When a site visitor asks for a demo of a specific product or from the company in general',
    description:
      'Triggered when a site visitor asks for a demo of a specific product or from the company in general',
    scenarioExamples: [
      'Can I get a demo of your product?',
      'Can I set up some time with someone to see the product in action?',
      "I'm interested in your product, is a member of your team able to walk me through your capabilities?",
    ],
    id: 'DEMOS',
  },
  {
    name: 'Upgrades',
    prompt:
      'When a site visitor inquires about upgrading their account or subscription/tier',
    description:
      'Triggered when a site visitor inquires about upgrading their account or subscription/tier',
    scenarioExamples: [
      'I need to upgrade my plan',
      'Can I speak with someone about upgrading my subscription?',
      'I need to move to a higher plan/tier',
    ],
    id: 'UPGRADES',
  },
  {
    name: 'Renewals',
    prompt:
      'When a site visitor inquires about renewing their account or subscription ',
    description:
      'Triggered when a site visitor inquires about renewing their account or subscription ',
    scenarioExamples: [
      "I'd like to speak with someone about renewing my subscription",
      'Renew subscription',
      'Renew account',
    ],
    id: 'RENEWALS',
  },
  {
    name: 'Create custom scenario',
    description: 'Create your own custom scenario from scratch',
    isEmpty: true,
    id: 'CUSTOM',
  },
]

export const GUARDRAILS_NAMES = [
  'Company Weaknesses',
  'Competitors',
  'Self Identity',
  'Identity',
  'Data Security and Compliance',
  'No Human Redirect',
  'Meetings',
  'Recommendations',
  'Moderation',
  'Off-topic',
]
